import { Dropdown, Modal, Button, Form } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import navdots from '../../../Assets/images/navdots.svg';
function RequestorListActionsDropdown({ requestor, handleEditRequestor, handleShowTrainingModal, handleShowDeactivateModal, handleShowDeleteModal }) { 
    return (  
        <>
            <div className="dropdown">
                <Dropdown>
                    <Dropdown.Toggle variant="" className="btn btn-primary dropdown-toggle" id="dropdown-basic">
                        <img src={navdots} alt="More actions" />
                    </Dropdown.Toggle>

                    <Dropdown.Menu className="el-action">
                        {/* <Dropdown.Item onClick={handleEditRequestor}>
                            <label>Edit Requestor</label>
                        </Dropdown.Item> */}
                        <Dropdown.Item as={Link} to={`requestor-profile`} state={{ requestor }}>
                            <label>Edit Requestor</label>
                        </Dropdown.Item>
                        {requestor.request_count === 0 && ( 
                        <Dropdown.Item onClick={handleShowDeleteModal}>
                            <label>Delete Requestor</label>
                        </Dropdown.Item>)
                        }
                        <Dropdown.Item onClick={handleShowTrainingModal}>
                            <label>Training Status</label>
                        </Dropdown.Item>
                        {/* onClick={() => handleChangeStatus(requestor, requestor.active)} */}
                        <Dropdown.Item onClick={handleShowDeactivateModal}>
                            <label className={requestor.active ? `text-danger` : `text-success`}>{requestor.active ? 'Deactivate' : 'Activate'}</label>
                        </Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </div> 
        </>
    );
}

export default RequestorListActionsDropdown;